import { render, staticRenderFns } from "./HeaderCard.vue?vue&type=template&id=0bea0d08&scoped=true&"
import script from "./HeaderCard.vue?vue&type=script&lang=js&"
export * from "./HeaderCard.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCard.vue?vue&type=style&index=0&id=0bea0d08&prod&scoped=true&lang=scss&"
import style1 from "./HeaderCard.vue?vue&type=style&index=1&id=0bea0d08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bea0d08",
  null
  
)

export default component.exports